import { events } from '@/data/content';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { SEO } from '@/components/SEO';
import { IconCalendar } from '@tabler/icons-react';

const Events = () => {
  return (
    <div className="min-h-screen bg-background py-12">
      <SEO
        title="Events & Classes"
        description="Join us for in-store events, cooking classes, and community gatherings. Free to attend."
      />
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-4xl font-bold text-foreground">Events & Classes</h1>
          <Badge variant="secondary">Free to attend</Badge>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {events.map((event, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader>
                <Badge variant="outline" className="w-fit mb-2">
                  <IconCalendar className="h-3 w-3 mr-1" />
                  {event.date}
                </Badge>
                <CardTitle className="text-2xl">{event.title}</CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <CardDescription className="text-muted-foreground">
                  {event.desc}
                </CardDescription>
                <Button className="w-full">RSVP</Button>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Events;
